import { render, staticRenderFns } from "./adsense.vue?vue&type=template&id=00a3bbda&scoped=true&"
import script from "./adsense.vue?vue&type=script&lang=js&"
export * from "./adsense.vue?vue&type=script&lang=js&"
import style0 from "./adsense.vue?vue&type=style&index=0&id=00a3bbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3bbda",
  null
  
)

export default component.exports